var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"unstruct"}},[_c('organization-banner'),_c('app-toolbar'),_c('app-drawer'),_c('notification-snackbars-wrapper'),_c('refresh'),_c('v-main',[_c('div',[_c('v-container',{attrs:{"ma-0":"","pa-0":"","fluid":""}},[_c('router-view')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }